
// useful methods for working with Attachments

import * as _ from 'lodash'

export default {

    /**
     * Special pseudo-group name for default handouts - these are not Attachments, but can live beside
     * them in SurveyNotes (see providers/Handouts.js)
     */
    DEFAULT_HANDOUTS_GROUP: 'DEFAULT_HANDOUTS',
    DEFAULT_HANDOUTS_GROUP_LABEL: 'Exercising with Medical Conditions',

    /**
     * Returns an object with the (sorted) groups as keys, and a list of Attachments (sorted by name)
     * as the value of each key.
     */
    getGroupedSortedAttachments(attachments) {
        const groups = _.groupBy(attachments, 'group')
        _.each(_.keys(groups), (group) => {
            groups[group] = _.sortBy(groups[group], (item) => {
                return item.name
            })
        })
        return groups
    },

    /**
     * Returns an object in the same format as getGroupedSortedAttachments, but taking "handout" objects
     * (see providers/SurveyNote::initHandouts) as input.
     */
    getGroupedSortedHandouts(handouts) {
        const groups = _.groupBy(handouts, 'group')
        _.each(_.keys(groups), (group) => {
            groups[group] = _.sortBy(groups[group], (item) => {
                return item.label
            })
        })
        return groups
    }

}
